import $ from 'jquery'

/**
 * Connexion PHC Go (template de page PHC Go Login et layout du même nom).
 *
 * Version nettoyée du script legacy de phcsoftware.com : l'appel à l'API des
 * installations, le choix de l'installation et la redirection sont désormais
 * gérés côté serveur par TemplatePhcGoLoginService via les hooks du formulaire
 * ACFE. Il ne reste ici que l'habillage du formulaire :
 *
 * - le bouton de soumission reste désactivé tant qu'aucun email n'est saisi ;
 * - le spinner plein écran couvre la validation ajax d'ACF puis la soumission,
 *   qui se termine par une redirection ou par le rendu du message de succès.
 */
export class PhcGoLogin {

  constructor() {
    this.$containers = $('[data-js-phc-go-login]')

    if (!this.$containers.length) {
      return
    }

    this.$containers.each((index, element) => this.initContainer($(element)))

    // ACF valide le formulaire en ajax avant de le soumettre réellement : sans ce
    // hook le spinner resterait affiché quand la validation renvoie une erreur.
    if (window.acf) {
      window.acf.addAction('validation_failure', this.hideSpinners.bind(this))
    }
  }

  initContainer($container) {
    const $form = $container.find('form')
    const $email = $form.find('input[type="email"]')
    const $submit = $form.find('[type="submit"]')

    if (!$email.length) {
      return
    }

    const toggleSubmit = () => $submit.prop('disabled', $email.val().trim().length === 0)

    $email.on('input', toggleSubmit)
    $form.on('submit', () => $container.find('.spinner').addClass('active'))

    toggleSubmit()
  }

  hideSpinners() {
    this.$containers.find('.spinner').removeClass('active')
  }
}
